module.exports = __webpack_public_path__ + "img/details.267e5124.svg";